export type Preset = "today" | "week" | "month" | "year" | "custom";
export type DateRange = { start: string; end: string };


const zeroTime = (d: Date) => { d.setHours(0, 0, 0, 0); return d; };
const pad2 = (n: number) => (n < 10 ? `0${n}` : `${n}`);
const formatYmdLocal = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;


export const getMonthRange = (): DateRange => {
    const d = new Date();
    const start = zeroTime(new Date(d.getFullYear(), d.getMonth(), 1));
    const end = zeroTime(new Date(d.getFullYear(), d.getMonth() + 1, 0));
    return { start: formatYmdLocal(start), end: formatYmdLocal(end) };
};


export const getTodayRange = (): DateRange => {
    const t = zeroTime(new Date());
    return { start: formatYmdLocal(t), end: formatYmdLocal(t) };
};


export const getWeekRange = (): DateRange => {
    const d = zeroTime(new Date());
    const day = d.getDay();
    const diffToMonday = (day + 6) % 7;
    const start = new Date(d);
    start.setDate(d.getDate() - diffToMonday);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    return { start: formatYmdLocal(start), end: formatYmdLocal(end) };
};


export const getYearRange = (): DateRange => {
    const d = new Date();
    const start = zeroTime(new Date(d.getFullYear(), 0, 1));
    const end = zeroTime(new Date(d.getFullYear(), 11, 31));
    return { start: formatYmdLocal(start), end: formatYmdLocal(end) };
};